import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './delete-property-modal.module.scss';
import { trackEvent } from '../../../../../shared/services/utils/tracking/tracking.service';
import Modal from '../../../../../shared/components/core-ui/modal/modal.component';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { PropertyUiModel } from '../../../../../shared/ui-models/property.ui-model';

export interface DeletePropertyModalProps {
  data: {
    property?: PropertyUiModel;
  };
  config: {
    showModal: boolean;
  };
  eventHandlers: {
    cancelHandler: () => void;
    deletePropertyHandler: (property: PropertyUiModel) => void;
  };
}

/**
 * functional component DeletePropertyModal
 * @param {DeletePropertyModalProps}
 */
export const DeletePropertyModal: React.FC<DeletePropertyModalProps> = ({
  data,
  config,
  eventHandlers
}) => {
  const { t } = useTranslation();
  const isMobileView = useWindowResizer();

  const handleDeletePropertySubmit = () => {
    if (data && data.property) {
      eventHandlers.deletePropertyHandler(data.property);
    }
  };

  return (
    <Modal
      config={{ showModal: config.showModal, fullScreen: false, showClose: true }}
      eventHandlers={{
        closeModalHandler: () => {
          eventHandlers.cancelHandler();
        }
      }}
    >
      <div className={styles['add-property-modal']}>
        <div className={styles['add-property-modal__title']}>
          {t('PROPERTY_MODULE.LIST_CONTAINER.DELETE_PROPERTY_MODAL.TITLE')}
        </div>
        <div className={styles['add-property-modal__description']}>
          {`${t('PROPERTY_MODULE.LIST_CONTAINER.DELETE_PROPERTY_MODAL.DESCRIPTION')} ${
            data.property?.name
          }`}
        </div>
      </div>
      <div className={styles['add-property-modal--actions']}>
        <Button
          onClick={() => {
            eventHandlers.cancelHandler();
            trackEvent('record_edit_cancelled', { entity: 'property', method: 'cancel' });
          }}
          tracking={{ event: 'record_edit_cancelled', entity: 'property', method: 'cancel' }}
          size={isMobileView ? ButtonSize.full : ButtonSize.medium}
          type={ButtonType.primaryInverted}
        >
          {t('PROPERTY_MODULE.LIST_CONTAINER.DELETE_PROPERTY_MODAL.CANCEL_BUTTON')}
        </Button>
        <Button
          onClick={handleDeletePropertySubmit}
          tracking={{
            event: 'record_saved',
            entity: 'property',
            action: 'update',
            outcome: 'success'
          }}
          type={ButtonType.danger}
          size={isMobileView ? ButtonSize.full : ButtonSize.medium}
        >
          {t('PROPERTY_MODULE.LIST_CONTAINER.DELETE_PROPERTY_MODAL.SUBMIT_BUTTON')}
        </Button>
      </div>
    </Modal>
  );
};
